import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CurrencyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CurrencyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 22C6.48584 22 2 17.5142 2 12C2 6.48584 6.48584 2 12 2C17.5142 2 22 6.48584 22 12C22 17.5142 17.5142 22 12 22ZM12 3C7.0376 3 3 7.0376 3 12C3 16.9624 7.0376 21 12 21C16.9624 21 21 16.9624 21 12C21 7.0376 16.9624 3 12 3Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.6108 12.3306H10.2105C9.93408 12.3306 9.71045 12.1069 9.71045 11.8306V8.65821C9.71045 8.38184 9.93408 8.15821 10.2105 8.15821H12.6108C13.7315 8.15821 14.6435 9.07032 14.6435 10.1909V10.2979C14.6435 11.4185 13.7314 12.3306 12.6108 12.3306ZM10.7105 11.3306H12.6108C13.1802 11.3306 13.6435 10.8672 13.6435 10.2979V10.1909C13.6435 9.62159 13.1802 9.15822 12.6108 9.15822H10.7105V11.3306Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.2114 15.9082H10.2104C9.93407 15.9082 9.71044 15.6846 9.71044 15.4082V11.8628C9.71044 11.5864 9.93407 11.3628 10.2104 11.3628H13.2114C14.4238 11.3628 15.4101 12.3491 15.4101 13.5615V13.7095C15.4101 14.9219 14.4238 15.9082 13.2114 15.9082ZM10.7104 14.9082H13.2114C13.8726 14.9082 14.4101 14.3706 14.4101 13.7095V13.5615C14.4101 12.9004 13.8726 12.3628 13.2114 12.3628H10.7104V14.9082Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.957 9.08203C11.6807 9.08203 11.457 8.8584 11.457 8.58203V6.75928C11.457 6.48291 11.6807 6.25928 11.957 6.25928C12.2334 6.25928 12.457 6.48291 12.457 6.75928V8.58203C12.457 8.8584 12.2334 9.08203 11.957 9.08203Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.957 17.7402C11.6807 17.7402 11.457 17.5166 11.457 17.2402V15.4175C11.457 15.1411 11.6807 14.9175 11.957 14.9175C12.2334 14.9175 12.457 15.1411 12.457 15.4175V17.2402C12.457 17.5166 12.2334 17.7402 11.957 17.7402Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CurrencyIcon;
